/* Keyteks rondas 12-21 (se carga despues de keyteks-hero.js):
   - aviso de entrega: antes de las 15:00 "llega hoy" con cuenta regresiva; despues "compra hoy y llega manana" sin tiempo.
     Se oculta a clientes con sesion cuya comuna no tiene entrega el mismo dia.
   - la cuenta regresiva de las super ofertas vence cada dia a las 23:59 (hora de Chile) y se reinicia sola
   - los mensajes de la franja abren las ventanas de informacion
   - en movil, las miniaturas de la ficha de producto pasan a una fila bajo la foto
   - el formulario del 10% no se abre solo en PC (en movil ya lo controla keyteks-hero.js) */
(function () {
  var CUT = 15;
  var TZ = 'America/Santiago';
  var COM = 'conchali,independencia,la granja,macul,nunoa,providencia,recoleta,san joaquin,san miguel,san ramon,santiago,cerrillos,cerro navia,estacion central,la cisterna,lo espejo,lo prado,pedro aguirre cerda,quinta normal,renca,el bosque,huechuraba,la florida,la pintana,la reina,las condes,penalolen,quilicura,vitacura,colina,lo barnechea,maipu,padre hurtado,pudahuel,puente alto,san bernardo'.split(',');
  var ALIAS = { 'santiago centro': 'santiago', 'las condes de santiago': 'las condes', 'chicureo': 'colina', 'la dehesa': 'lo barnechea', 'pac': 'pedro aguirre cerda' };

  function norm(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[^a-z ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function outside() {
    var c = document.querySelector('[data-kt-cov][data-city]');
    if (!c) return false;
    var n = norm(c.getAttribute('data-city'));
    if (!n) return false;
    n = ALIAS[n] || n;
    return COM.indexOf(n) < 0;
  }
  function secs() {
    try {
      var v = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { v[x.type] = parseInt(x.value, 10); });
      var n = (v.hour % 24) * 3600 + v.minute * 60 + v.second;
      return isNaN(n) ? null : n;
    } catch (e) { return null; }
  }
  function weekday() {
    try { return new Intl.DateTimeFormat('es-CL', { timeZone: TZ, weekday: 'long' }).format(new Date()); } catch (e) { return ''; }
  }
  function state() {
    var n = secs();
    if (n === null) return null;
    var c = CUT * 3600;
    return n < c ? { today: true, left: c - n } : { today: false, left: 0 };
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hm(s) { var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60); return (h > 0 ? h + ' h ' : '') + m + ' min'; }
  function hms(s) { return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60); }
  function asButton(el, key) {
    if (!document.getElementById('kt-m-' + key)) return;
    el.setAttribute('data-kt-modal', key);
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
  }
  function keyOf(el) {
    var k = el.getAttribute('data-kt-modal');
    if (k) return k;
    var t = norm(el.textContent);
    if (t.indexOf('envio gratis') > -1) return 'envio';
    if (t.indexOf('entrega hoy') > -1 || t.indexOf('recibelo') > -1) return 'hoy';
    if (t.indexOf('mercadolider') > -1) return 'meli';
    if (t.indexOf('garantia') > -1) return 'garantia';
    return '';
  }

  function delivery() {
    if (!state()) return;
    var out = outside();
    var isHome = !!document.querySelector("#MainContent [id^='Slider-'].slideshow");
    var boxes = [], shorts = [], bars = [];

    var sd = document.querySelector('.kt-sd');
    if (sd) {
      if (out) {
        sd.remove();
      } else {
        var old = sd.querySelector('span');
        if (old) {
          var fresh = document.createElement('span');
          old.parentNode.replaceChild(fresh, old);
          boxes.push(fresh);
          asButton(sd, 'hoy');
        }
        var qty = document.querySelector('.product__info-container > .product-form__quantity');
        if (qty) qty.parentNode.insertBefore(sd, qty);
      }
    }

    document.querySelectorAll('.kt-rot').forEach(function (rot) {
      Array.prototype.slice.call(rot.children).forEach(function (el) {
        var key = keyOf(el);
        var isCount = el.getAttribute('data-kt-key') === 'hoy' || norm(el.textContent).indexOf('recibelo') > -1;
        if (key === 'hoy' && out) { el.remove(); return; }
        if (isCount && isHome) { el.remove(); return; }
        if (key && !el.getAttribute('data-kt-modal')) asButton(el, key);
        if (!isCount) return;
        var copy = el.cloneNode(false);
        el.parentNode.replaceChild(copy, el);
        shorts.push(copy);
      });
      if (!rot.querySelector('.on') && rot.firstElementChild) rot.firstElementChild.classList.add('on');
    });

    if (isHome && !out) {
      var strip = document.querySelector('#MainContent .kt-rot');
      var host = strip ? (strip.closest('.shopify-section') || strip) : null;
      if (host) {
        var bar = document.createElement('div');
        bar.className = 'kt-today';
        bar.innerHTML = "<svg viewBox='0 0 24 24'><path d='M13 2 4 14h7l-1 8 9-12h-7z'/></svg><span></span>";
        asButton(bar, 'hoy');
        host.parentNode.insertBefore(bar, host);
        bars.push(bar.querySelector('span'));
      }
    }

    function put(list, h) { list.forEach(function (t) { if (t.ktH !== h) { t.innerHTML = h; t.ktH = h; } }); }
    function paint() {
      var s = state();
      if (!s) return;
      if (s.today) {
        var wd = weekday();
        put(boxes, '<b>Llega hoy' + (wd ? ' ' + wd : '') + '</b> en Santiago urbano<br>Comprando dentro de las próximas <b>' + hm(s.left) + '</b>');
        put(shorts, 'Llega <b>hoy</b> en Santiago comprando en <b>' + hm(s.left) + '</b>');
        put(bars, "Llega <b class='kt-today__d'>hoy</b> en Santiago si compras en<b class='kt-today__c'>" + hms(s.left) + '</b>');
      } else {
        var late = 'Compra hoy y llega <b>mañana</b> en Santiago urbano';
        put(boxes, late);
        put(shorts, late);
        put(bars, "Compra hoy y llega <b class='kt-today__d'>mañana</b> en Santiago urbano");
      }
    }
    if (boxes.length || shorts.length || bars.length) { paint(); setInterval(paint, 1000); }
  }

  /* La galeria (media-gallery) debe estar inicializada antes de mover las miniaturas,
     para que conserve su referencia y los clics sigan cambiando la foto. */
  function moveThumbs() {
    var th = document.querySelector('.product media-gallery .thumbnail-slider');
    var info = document.querySelector('.product__info-container');
    if (!th || !info) return;
    if (th.querySelectorAll('.thumbnail-list__item').length < 2) return;
    var before = info.querySelector('.kt-sd') || info.querySelector('.product-form__quantity');
    if (!before || before.parentNode !== info) return;
    th.classList.add('kt-thumbs');
    info.insertBefore(th, before);
  }
  function thumbs() {
    if (!window.matchMedia || !window.matchMedia('(max-width:749px)').matches) return;
    if (!document.querySelector('.product media-gallery')) return;
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('media-gallery').then(function () { setTimeout(moveThumbs, 0); });
    } else {
      window.addEventListener('load', moveThumbs);
    }
  }

  function dailyTimers() {
    function roll() {
      var n = secs();
      if (n === null) return;
      var end = new Date(Date.now() + (86399 - n) * 1000).toISOString();
      document.querySelectorAll('.kt-timer[data-end]').forEach(function (t) {
        t.setAttribute('data-end', end);
        t.style.display = '';
      });
    }
    roll();
    setInterval(roll, 30000);
  }

  function formsGuard() {
    if (!window.MutationObserver || !window.matchMedia || !window.matchMedia('(min-width:750px)').matches) return;
    var n = 0, t = setInterval(function () {
      var f = document.querySelector('shopify-forms-embed'), root = f && f.shadowRoot, app = root && root.querySelector('#app-embed');
      if (app) {
        clearInterval(t);
        var userOpened = false;
        root.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-testid=form-teaser]')) userOpened = true;
        }, true);
        var guard = function () {
          if (app.getAttribute('data-current-step') === 'tease') { userOpened = false; return; }
          if (!userOpened) { var x = root.querySelector('[aria-label="Close modal"]'); if (x) x.click(); }
        };
        new MutationObserver(guard).observe(app, { attributes: true, attributeFilter: ['data-current-step'] });
        guard();
        return;
      }
      if (++n > 60) clearInterval(t);
    }, 500);
  }

  function init() {
    try { delivery(); } catch (e) {}
    try { thumbs(); } catch (e) {}
    document.documentElement.classList.add('kt-bar-done');
    dailyTimers();
    formsGuard();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
